import HeaderIndicator from './HeaderIndicator'

export default HeaderIndicator



// WEBPACK FOOTER //
// ./src/modules/Indicators/Header/HeaderIndicator/index.js